import React from 'react'

import RadioButtonElement, {
  type RadioButtonElementProps
} from './radio-button-element'

export type RadioButtonInputProps = RadioButtonElementProps

// a transparent native radio button filling its Box
const RadioButtonInput = (props: RadioButtonInputProps) => (
  <RadioButtonElement {...props} />
)

export default RadioButtonInput
